module.exports = __webpack_public_path__ + "static/feature-team-d2715c485993553cbb14da8c8ff7398d.jpg";